import 'popper.js';
import 'bootstrap';

(function ($, Drupal) {

  'use strict';

  Drupal.behaviors.secf = {
    attach: function (context) {
      autoExternalLinks('a[href^="http"]', context);
      autoExternalLinks('a[href^="//"]', context);

      // Hide mobile menu if menu is empty
      // Via twig does not detect properly the empty regions when
      // is related with permissions.
      // @TODO move this to a preprocess.
      if($('.navbar-collapse .nav').length < 1) {
        $('.navbar-toggler').hide();
      }
    }
  };

  /**
   * Auto external links new window.
   *
   * @param string selector
   *   Selector.
   * @param object context
   *   Drupal context.
   */
  function autoExternalLinks(selector, context) {
    $(selector, context).once('auto-external').each(function () {
      if ($(this)[0].hostname !== window.location.hostname) {
        $(this).attr('target', '_blank');
      }
    });
  }

})(jQuery, Drupal);
